import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LandingPage from "../pages/LandingPage";
import LoginPage from "../pages/LoginPage";

const AuthLoadingScreen = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50">
    <div className="h-9 w-9 animate-spin rounded-full border-4 border-indigo-100 border-t-indigo-600" />
  </div>
);

export const HomeRoute = () => {
  const { user, authLoading } = useAuth();
  if (authLoading) return <AuthLoadingScreen />;
  return user ? <LandingPage /> : <LoginPage />;
};

export const LoginRoute = () => {
  const { user, authLoading } = useAuth();
  if (authLoading) return <AuthLoadingScreen />;
  return user ? <Navigate to="/" replace /> : <LoginPage />;
};
